<template>
	<div>
		<div class="loading" v-if="loadingLocation">
			<div class="sk-circle">
				<div class="sk-circle1 sk-child"></div>
				<div class="sk-circle2 sk-child"></div>
				<div class="sk-circle3 sk-child"></div>
				<div class="sk-circle4 sk-child"></div>
				<div class="sk-circle5 sk-child"></div>
				<div class="sk-circle6 sk-child"></div>
				<div class="sk-circle7 sk-child"></div>
				<div class="sk-circle8 sk-child"></div>
				<div class="sk-circle9 sk-child"></div>
				<div class="sk-circle10 sk-child"></div>
				<div class="sk-circle11 sk-child"></div>
				<div class="sk-circle12 sk-child"></div>
			</div>
		</div>
		<modal-step-one
			v-if="locationInactive"
			@active-location="$emit('active-location')"
			@get-address="$emit('get-address', $event)"
		></modal-step-one>
		<modal-step-two
			v-show="!locationInactive"
			:address="address"
			:address-location="addressLocation"
			:alias="alias"
			:country-code="countryCode"
			:settings="settings"
			@change-location="$emit('change-location')"
			@get-data="$emit('get-data', $event)"
			@on-center-changed="$emit('on-center-changed', $event)"
			@save-location="$emit('save-location')"
		></modal-step-two>
	</div>
</template>
<script>
	import modalStepOne from '@/components/market-place/modal-step-one';
	import modalStepTwo from '@/components/market-place/modal-step-two';

	export default {
		name: 'modal-information',
		components: {
			modalStepOne,
			modalStepTwo,
		},
		props: {
			address: String,
			addressLocation: String,
			alias: String,
			countryCode: String,
			loadingLocation: {
				default: false,
				type: Boolean,
			},
			locationInactive: {
				default: true,
				type: Boolean,
			},
			settings: {
				default: () => {},
				type: Object,
			},
		},
	};
</script>
<style lang="scss" scoped>
	// Componente loading

	.loading {
		background: rgba(0, 0, 0, .5);
		height: 100%;
		left: 0px;
		position: absolute;
		top: 0px;
		width: 100%;
		z-index: 3;
	}

	.sk-circle {
		bottom: 0px;
		height: 40px;
		left: 0px;
		margin: auto;
		position: absolute;
		right: 0px;
		top: 0px;
		width: 40px;
	}

	.sk-circle .sk-child {
		height: 100%;
		left: 0;
		position: absolute;
		top: 0;
		width: 100%;
	}

	.sk-circle .sk-child:before {
		background-color: color(white);
		border-radius: 100%;
		content: '';
		display: block;
		height: 28%;
		margin: -12px auto;
		width: 28%;
		-webkit-animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
				animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
	}

	.sk-circle .sk-circle2 {
		-webkit-transform: rotate(30deg);
			-ms-transform: rotate(30deg);
				transform: rotate(30deg);
	}

	.sk-circle .sk-circle3 {
		-webkit-transform: rotate(60deg);
			-ms-transform: rotate(60deg);
				transform: rotate(60deg);
	}

	.sk-circle .sk-circle4 {
		-webkit-transform: rotate(90deg);
			-ms-transform: rotate(90deg);
				transform: rotate(90deg);
	}

	.sk-circle .sk-circle5 {
		-webkit-transform: rotate(120deg);
			-ms-transform: rotate(120deg);
				transform: rotate(120deg);
	}

	.sk-circle .sk-circle6 {
		-webkit-transform: rotate(150deg);
			-ms-transform: rotate(150deg);
				transform: rotate(150deg);
	}

	.sk-circle .sk-circle7 {
		-webkit-transform: rotate(180deg);
			-ms-transform: rotate(180deg);
				transform: rotate(180deg);
	}

	.sk-circle .sk-circle8 {
		-webkit-transform: rotate(210deg);
			-ms-transform: rotate(210deg);
				transform: rotate(210deg);
	}

	.sk-circle .sk-circle9 {
		-webkit-transform: rotate(240deg);
			-ms-transform: rotate(240deg);
				transform: rotate(240deg);
	}

	.sk-circle .sk-circle10 {
		-webkit-transform: rotate(270deg);
			-ms-transform: rotate(270deg);
				transform: rotate(270deg);
	}

	.sk-circle .sk-circle11 {
		-webkit-transform: rotate(300deg);
			-ms-transform: rotate(300deg);
				transform: rotate(300deg);
	}

	.sk-circle .sk-circle12 {
		-webkit-transform: rotate(330deg);
			-ms-transform: rotate(330deg);
				transform: rotate(330deg);
	}

	.sk-circle .sk-circle2:before {
		-webkit-animation-delay: -1.1s;
				animation-delay: -1.1s;
	}

	.sk-circle .sk-circle3:before {
		-webkit-animation-delay: -1s;
				animation-delay: -1s;
	}

	.sk-circle .sk-circle4:before {
		-webkit-animation-delay: -0.9s;
				animation-delay: -0.9s;
	}

	.sk-circle .sk-circle5:before {
		-webkit-animation-delay: -0.8s;
				animation-delay: -0.8s;
	}

	.sk-circle .sk-circle6:before {
		-webkit-animation-delay: -0.7s;
				animation-delay: -0.7s;
	}

	.sk-circle .sk-circle7:before {
		-webkit-animation-delay: -0.6s;
				animation-delay: -0.6s;
	}

	.sk-circle .sk-circle8:before {
		-webkit-animation-delay: -0.5s;
				animation-delay: -0.5s;
	}

	.sk-circle .sk-circle9:before {
		-webkit-animation-delay: -0.4s;
				animation-delay: -0.4s;
	}

	.sk-circle .sk-circle10:before {
		-webkit-animation-delay: -0.3s;
				animation-delay: -0.3s;
	}

	.sk-circle .sk-circle11:before {
		-webkit-animation-delay: -0.2s;
				animation-delay: -0.2s;
	}

	.sk-circle .sk-circle12:before {
		-webkit-animation-delay: -0.1s;
				animation-delay: -0.1s;
	}

	@-webkit-keyframes sk-circleBounceDelay {
		0%, 80%, 100% {
			-webkit-transform: scale(0);
					transform: scale(0);
		} 40% {
			-webkit-transform: scale(1);
					transform: scale(1);
		}
	}

	@keyframes sk-circleBounceDelay {
		0%, 80%, 100% {
			-webkit-transform: scale(0);
					transform: scale(0);
		} 40% {
			-webkit-transform: scale(1);
					transform: scale(1);
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/modal-information.vue